<ngb-tabset>
  <ngb-tab>
    <ng-template ngbTabTitle>
      {{'Station schedule' | translate}}
    </ng-template>
    <ng-template ngbTabContent>
      <qm-station-table [station]="station"></qm-station-table>
    </ng-template>
  </ngb-tab>
</ngb-tabset>
